// The synthetic org settings used while the session is in enterprise mode.
// useFeatures() and the map read `state.org.settings`; in enterprise mode there
// is no real org, so this object answers them: Reports and Alerts on, every
// other catalog flag explicitly off, platform defaults for status thresholds
// and map labels (no company's own overrides leak across companies).
import { FEATURE_KEYS } from '@/lib/featureModules';
import { DEFAULT_STATUS_THRESHOLDS } from '@/lib/statusThresholds';
import { DEFAULT_LABEL_STYLE } from '@/features/map/labelStyle';

const ENABLED = new Set(['featureReports', 'featureAlerts']);

export const ENTERPRISE_SETTINGS = Object.freeze({
  ...Object.fromEntries(FEATURE_KEYS.map((k) => [k, ENABLED.has(k)])),
  statusThresholds: { ...DEFAULT_STATUS_THRESHOLDS },
  // Vehicle name + its company on every label (the enterprise view has no
  // label editor). The name is always the first line; `company` the second.
  mapLabelStyle: { ...DEFAULT_LABEL_STYLE, shape: 'pill', fields: ['company'], showFieldLabels: false },
});

/** The org-shaped stand-in for an enterprise scope (`state.org`). */
export function enterpriseOrg(enterprise) {
  return {
    id: `enterprise:${enterprise.id}`,
    name: enterprise.name,
    plan: null,
    role: 'viewer',
    settings: ENTERPRISE_SETTINGS,
    enterprise: true,
  };
}
